import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { usersService } from "../end-points/users"
import { RegisterUsers, Role } from "@/types/users"
import { toast } from "@/hooks/use-toast"
import { UserAuthenticated } from "@/types/auth"

interface CineBlocksErr extends Error {
  data: {
    statusCode: number
  }
}

export const useRegisterUser = () => {
  return useMutation({
    mutationFn: (data: RegisterUsers) => usersService.register(data),
    onSuccess: () => {
      toast({
        title: "Usuário criado",
        description: "Usuário cadastrado com sucesso",
        variant: "success",
      })
    },
    onError: (err: CineBlocksErr) => {
      if (err?.data?.statusCode === 409) {
        toast({
          title: "Erro ao criar usuário",
          description: "Email ou cpf já cadastrado!",
          variant: "destructive",
        })

        return
      }

      toast({
        title: "Erro ao criar usuário",
        description: "Não foi possível cadastrar o usuário",
        variant: "destructive",
      })
    }
  })
}

export const useMe = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => usersService.me(),
    staleTime: 1000 * 60 * 60, // 1 hora
  })
}

export const useChangeRole = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: { id: number, role: Role }) => usersService.changeRole(data.id, data.role),
    onSuccess: (data) => {
      queryClient.setQueryData(['person-me'], (oldData: any) => {
        if (!oldData) return oldData
        return {
          ...oldData,
          user: {
            ...oldData.user,
            onboarding_steps: 3
          }
        }
      })

      queryClient.setQueryData(['me'], (oldData: any) => {
        if (!oldData) return oldData
        return {
          ...oldData,
          role: data.user.role
        }
      })
      queryClient.invalidateQueries({ queryKey: ['me', 'person-me'] })
      console.log("Change role success:", data)

      toast({
        title: "Perfil alterado",
        description: "Perfil alterado com sucesso",
        variant: "success",
      })
    },
    onError: (err) => {
      console.log(err)
      toast({
        title: "Erro ao alterar perfil",
        description: "Não foi possível alterar o perfil",
        variant: "destructive",
      })
    }
  })
}

export const useUpdateOnboardingSteps = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: { id_user: number, step: string }) => usersService.updateOnboardingStep(data),
    onSuccess: (data) => {
      queryClient.setQueryData(['person-me'], (oldData: any) => {
        if (!oldData) return oldData
        return {
          ...oldData,
          user: {
            ...oldData.user,
            onboarding_steps: data.user.onboarding_steps
          }
        }
      })
      queryClient.invalidateQueries({ queryKey: ['me', 'person-me'] })
      console.log("Update onboarding steps success:", data)
    },
    onError: (err) => {
      console.log(err)
    }
  })
}
